export default __webpack_public_path__ + "static/bg_top_service_03-bd6352f072f4d4ce1a46d99715880dd7.mp4";